export default __webpack_public_path__ + "static/media/up_arrow.1bd1ba29.svg";